import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Check } from 'lucide-react'
import { Checkbox } from '../../ui/checkbox'
import { Input } from '../../ui/input'
import Avatar from '../Avatar/Avatar'

function CoachMultiSelect({ coaches, value, onChange }) {
  const [search, setSearch] = useState('')

  const safeCoaches = coaches || []
  const safeValue = value || []

  const selectedCoaches = safeCoaches.filter((c) => safeValue.some((v) => v.id === c.id))
  const filteredCoaches = safeCoaches.filter(
    (c) =>
      c.fullName?.toLowerCase().includes(search.toLowerCase()) || c.label?.toLowerCase().includes(search.toLowerCase())
  )

  function handleToggle(coach) {
    const isSelected = safeValue.some((v) => v.id === coach.id)
    if (isSelected) {
      onChange(safeValue.filter((c) => c.id !== coach.id))
    } else {
      onChange([...safeValue, coach])
    }
  }

  return (
    <div className="space-y-3">
      <Input
        placeholder="Search coaches..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="h-9"
      />

      {selectedCoaches.length > 0 && (
        <div className="flex items-center gap-2 flex-wrap p-2 bg-gray-50 rounded-md">
          {selectedCoaches.map((coach) => (
            <div key={coach.id} className="flex items-center gap-1 bg-white rounded px-2 py-1 border border-gray-200">
              <Avatar
                fullName={coach.fullName}
                cloudinaryPhotoPublicId={coach.cloudinaryPhotoPublicId}
                size={5}
                userId={coach.id}
              />
              <span className="text-xs text-gray-900">{coach.label || coach.fullName}</span>
            </div>
          ))}
        </div>
      )}

      <div className="max-h-[300px] overflow-y-auto border border-gray-200 rounded-md">
        {filteredCoaches.length === 0 ? (
          <div className="text-center py-4 text-gray-500 text-sm">No coaches found</div>
        ) : (
          <div className="divide-y divide-gray-200">
            {filteredCoaches.map((coach) => {
              const isSelected = safeValue.some((v) => v.id === coach.id)
              return (
                <div
                  key={coach.id}
                  className="flex items-center space-x-2 p-3 hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleToggle(coach)}
                >
                  <Checkbox checked={isSelected} />
                  <Avatar
                    fullName={coach.fullName}
                    cloudinaryPhotoPublicId={coach.cloudinaryPhotoPublicId}
                    size={5}
                    userId={coach.id}
                  />
                  <span className="flex-1 text-sm text-gray-900">{coach.label || coach.fullName}</span>
                  {isSelected && <Check className="h-4 w-4 text-green-600" />}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

CoachMultiSelect.propTypes = {
  coaches: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default CoachMultiSelect
